import { get } from 'lodash';
import React from 'react';
import { ANTRAGS_STATUS } from '../../../../../../lib/constants/constant';
import { TreeNodeType } from '../../../../../../lib/types/types';
import AblehnungsbescheidAntragGlobal from './content/AblehnungsbescheidAntragGlobal';
import FoerderBescheidAntragGlobal from './content/FoerderBescheidAntragGlobal';

// import schemas
import Schema from '../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

export const TreeStructureAntragBescheidGlobal = (application: any) => {
	let treeNodes: TreeNodeType[] = [];

	if (get(application, `${P.Foerderbescheid_Foerderbescheid.path}.id`)) {
		if (get(application, P.Antragstatus_Antragstatus.path, '') === ANTRAGS_STATUS.abgelehnt) {
			treeNodes = [
				{
					label: 'Ablehnungsbescheid',
					content: <AblehnungsbescheidAntragGlobal />,
				},
			];
		} else {
			treeNodes = [
				{
					label: 'Förderbescheid',
					content: <FoerderBescheidAntragGlobal />,
				},
			];
		}
	}

	return treeNodes;
};
